import { render, staticRenderFns } from "./WelcomeNewAccount.vue?vue&type=template&id=25c3e6a8&scoped=true&"
import script from "./WelcomeNewAccount.vue?vue&type=script&lang=js&"
export * from "./WelcomeNewAccount.vue?vue&type=script&lang=js&"
import style0 from "./WelcomeNewAccount.vue?vue&type=style&index=0&id=25c3e6a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c3e6a8",
  null
  
)

export default component.exports